import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { helpCategories } from "./helpData";
import HelpCenterLayout from "./HelpCenterLayout";
import Breadcrumbs from "./Breadcrumbs";
import "../../css/HelpCenter.css";

const HelpCenterLanding = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "VelaKoda | Help Center";
  }, []);

  return (
    <HelpCenterLayout backFallbackTo="/">
      <Breadcrumbs items={[{ label: "All Collections" }]} />

      <header className="help-page-header">
        <h1 className="help-page-title">Help Center</h1>
        <p className="help-page-subtitle">
          Browse categories, open articles, and find the right answer quickly.
        </p>
      </header>

      <div className="help-collection-grid">
        {helpCategories.map((category) => (
          <div key={category.id} className="help-collection-card">
            <div className="help-collection-card-copy">
              <div className="help-collection-card-label">
                {category.displayTitle}
              </div>
              <div className="help-collection-card-title">{category.title}</div>
              <div className="help-collection-card-description">
                {category.summary}
              </div>
              <div className="help-collection-card-meta">
                {category.articles.length} articles
              </div>
            </div>
            <button
              type="button"
              className="help-collection-card-action"
              onClick={() => navigate(`/help/${category.id}`)}
            >
              View collection
            </button>
          </div>
        ))}
      </div>
    </HelpCenterLayout>
  );
};

export default HelpCenterLanding;
